function showPickupModalonClick() {
    //var buttonText = $(this).text().trim();
    //analytics.OrderTypeText(buttonText);
    $("#CurbsidePickup").hide();
    if (orderViewModel.hasCurbside && orderViewModel.hasCurbsideBeforeHours) {
        $("#CurbsidePickupBeforeHours").show();
        $("#before-curbside-hours-text").html(orderViewModel.curbsideAvailableMessage);
        $('#schedule-curbside-hours-text').html(orderViewModel.scheduleCurbsideMessage);
    }
    else if (orderViewModel.hasCurbside) {
        $("#CurbsidePickup").show();
        $("#CurbsidePickupBeforeHours").hide();
    }
    else {
        $("#CurbsidePickup").show();
        $("#CurbsidePickup .pickup-type-text, #CurbsidePickup img, #CurbsidePickup .switch-to-curbside").addClass("disabled");
        $("#CurbsidePickupBeforeHours").hide();
        $("#after-curbside-hours-text").html("Curbside pickup unavailable").show();
    }
    modalShowId('#PickupModal');
}

$(document).ready(function () {
    if ($('.change-order-type').length > 0) {
        //show the selection modal when the button is clicked
        $('.change-order-type').on('click', function () {
            showPickupModalonClick();
        });
    }
    $('.pickUP-modal-content-2').on('click', function () {
        if (!$(this).children('a').hasClass('disabled')) {
            orderViewModel.hasDeliveryLocator = false;
            orderViewModel.orderType = "curbside";
            orderViewModel.save();
            SwitchOrderType(orderViewModel.orderType);
        }
    });
    $('.pickUP-modal-content-1').on('click', function () {
        orderViewModel.hasDeliveryLocator = false;
        orderViewModel.orderType = "pickup";
        orderViewModel.save();
        SwitchOrderType(orderViewModel.orderType);
    });
    function SwitchOrderType(OrderType) {
        var cartId = orderViewModel.currentOrder.cartId;
        if (cartId) {
            var hdnCurbSideSeparator = $('#hdnCurbSideSeparator').val();
            var hdnVehicleColor = $('#hdnVehicleColor').val();
            var hdnVehicleType = $('#hdnVehicleType').val();
            curbDetail = hdnVehicleType + $('#hdnpreVechileType').val() + hdnCurbSideSeparator + hdnVehicleColor + $('#hdnpreVechileColor').val() + hdnCurbSideSeparator;
            var specialInstructionText = "";
            if (orderViewModel.orderType != "delivery") {
                specialInstructionText = $("#special-instructions-id .instructions-field").val();
            }
            else {
                specialInstructionText = $("#order-instruction .instructions-field").val();
            }
            var $setSpecialInstructions = $('#frmSetSpecialInstructions');
            var Curpickup = $('#comm-prefs-curb').is(":checked");
            $('[name="CartId"]', $setSpecialInstructions).val(cartId);
            $('[name="Instructions"]', $setSpecialInstructions).val(specialInstructionText);
            $('[name="IsCurbpickupEnabled"]', $setSpecialInstructions).val(Curpickup);
            $('[name="CurbDetails"]', $setSpecialInstructions).val(curbDetail);
            $('[name="OrderType"]', $setSpecialInstructions).val(OrderType);

            subwayScript.showSpinner();

            $.ajax({
                url: $setSpecialInstructions.attr('action'),
                type: 'POST',
                data: $setSpecialInstructions.serialize(),
                success: function (data) {
                    window.location.replace(window.location.pathname);
                    subwayScript.hideSpinner();
                },
                error: function (jqXhr) {
                    void 0;
                    subwayScript.hideSpinner();
                }
            });
        }
    }
    $('.pickup-locator').on('click', function () {
        analytics.startOrContinueOrder();
        var buttonText = $(this).text();
        analytics.orderType(buttonText);
        orderViewModel.orderType = buttonText;
        orderViewModel.save();
        orderViewModel.orderType = "pickup";
        orderViewModel.save();
        orderViewModel.hasDeliveryLocator = false;
        orderViewModel.DeliveryAddress.DirectDelivery = false;
        orderViewModel.save();
        if (((Url == HomeURL) || (Url == Homeurl)) && orderViewModel.IsRecentOrder == true) {
            orderViewModel.IsRecentOrder = false;
            orderViewModel.save();
            OrderHistoryStoreValidationAsync(orderViewModel.RecentOrdersCartID);
        }
        else if (window.location.href.split('/')[5] == RecentOrdersURL) {
            orderViewModel.IsRecentOrder = false;
            orderViewModel.save();
            OrderHistoryStoreValidationAsync(orderViewModel.RecentOrdersCartID);
        }
        else {
            window.location.href = subwayScript.navigation.getLocatorUrl();
        }
    });
    $('.curbside-locator').on('click', function () {
        analytics.startOrContinueOrder();
        var buttonText = $(this).text();
        analytics.orderType(buttonText);
        orderViewModel.orderType = buttonText;
        orderViewModel.save();
        orderViewModel.hasDeliveryLocator = false;
        orderViewModel.orderType = "curbside";
        orderViewModel.save();
        orderViewModel.DeliveryAddress.DirectDelivery = false;
        orderViewModel.save();

        if (((Url == HomeURL) || (Url == Homeurl)) && orderViewModel.IsRecentOrder == true) {
            orderViewModel.IsRecentOrder = false;
            orderViewModel.save();
            OrderHistoryStoreValidationAsync(orderViewModel.RecentOrdersCartID);
        }
        else if (window.location.href.split('/')[5] == RecentOrdersURL) {
            orderViewModel.IsRecentOrder = false;
            orderViewModel.save();
            OrderHistoryStoreValidationAsync(orderViewModel.RecentOrdersCartID);
        }
        else {
            window.location.href = subwayScript.navigation.getLocatorUrl();
        }

    });
});
